import { render, staticRenderFns } from "./BillingDetail.vue?vue&type=template&id=4ffc6b4f"
import script from "./BillingDetail.vue?vue&type=script&lang=js"
export * from "./BillingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports